// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-header[data-v-35399bce] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
